import { BreadCrumbs, LayoutWithoutHeader } from "lego-gui-lib";
import { observer } from "mobx-react-lite";
import React, { FC, useContext, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router";
import { Route } from "react-router-dom";
import { authStoreContext, mainStore } from "../core/mainStore";
import { versionContext } from "../core/model/version";
import { AppVersion } from "../feature/layout/AppVersion";
import { LanguageSelector } from "../feature/layout/LanguageSelector";
import { CustomerOwnerContextLabel } from "../feature/layout/CustomerOwnerContextLabel";
import { SideMenuBody } from "../feature/layout/sideMenu/SideMenuBody";
import { routes } from "../feature/routes";
import { useTranslation } from "react-i18next";

export const Admin: FC = observer(() => {
  const DEFAULT_PAGE = "/admin";

  const version = useContext(versionContext);

  const history = useHistory();
  const match = useRouteMatch();

  const { t } = useTranslation();

  const auth = useContext(authStoreContext);

  const [landingPageLink, setLandingPageLink] = useState(
    `/admin${auth.landingPage}`
  );

  const buttonConfig = {options: false, logout:true};
  const logoImgPath = process.env.PUBLIC_URL + "/logo.png";
  const headerTitle = t("hns:title");

  useEffect(() => {
    const landingUrl = `/admin${auth.landingPage}`;
    setLandingPageLink(landingUrl);
    if (history.location.pathname === DEFAULT_PAGE) {
      history.push(landingUrl);
    }
    version.fetchVersion();
  }, [mainStore.auth.currentUser]);

  return (
    <LayoutWithoutHeader
      appTitle={headerTitle}
      logo={logoImgPath}
      items={<SideMenuBody />}
      landingPageLink={landingPageLink}
      breadCrumbs={<BreadCrumbs />}
      customMenuItems={
        <>
          <CustomerOwnerContextLabel />
          <AppVersion apiVersion={version.apiVersion} />
          <LanguageSelector />
        </>
      }
      buttonConfig={buttonConfig}
    >
      {Object.keys(routes).map((route: any) => {
        const url = match.url + routes[route].url;
        const handler = routes[route].handler;
        return <Route key={url} path={url} render={handler} />;
      })}
    </LayoutWithoutHeader>
  );
});
